import { Component, ViewEncapsulation } from '@angular/core'
import { AngularFireDatabase } from 'angularfire2/database'
import { Observable } from 'rxjs/Observable'
import { ColumnApi, GridApi, GridOptions } from 'ag-grid/main'
import { AuthService } from './auth.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app'

  email: string
  password: string

  public userKey: string
  public user: {}
  public superuser = false

  public userMap: {}
  public brands: any[]
  public productMap: {}
  public products: any[]
  public retailers: any[]
  public stores: any[]

  public brandKey: string

  public monthNames: any[]

  public storePresences: any[]
  public productPresences: any[]

  private gridOptions: GridOptions
  public rowData: any[]
  public columnDefs: any[]
  public rowCount: string

  private api: GridApi
  private columnApi: ColumnApi

  constructor(public authService: AuthService, public db: AngularFireDatabase) {
    this.gridOptions = <GridOptions>{}
    this.loadData()
    this.columnDefs = this.createColumnDefs()
  }

  login() {
    this.authService.login(this.email, this.password)
    this.email = this.password = ''
  }

  logout() {
    this.authService.logout()
  }

  updateBrand() {
    this.loadData()
  }

  private onReady(params) {
    this.api = params.api
    this.columnApi = params.columnApi
  }

  private loadData() {
    this.setUser(() => {
      this.userMap = {}
      this.getAll('brands', (brandMap, brands) => {
        brands.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
        this.brands = brands
        if (this.brandKey == undefined && this.brands.length > 0) {
          this.brandKey = this.brands[0].key
        }
        this.getAll('retailers', (retailerMap, retailers) => {
          this.retailers = retailers
          this.getAll('stores', (storeMap, stores) => {
            this.stores = stores
            this.getAll('products', (productMap, products) => {
              this.productMap = productMap
              this.products = products
              this.getAll('statuses', (statusMap, statuses) => {
                let sorted = statuses
                sorted.sort((a, b) => {
                  return b.createdTime - a.createdTime
                })
                statuses = []
                var instances = {}
                sorted.forEach((status) => {
                  let key = status.productKey
                    + '|' + status.storeKey
                    + '|' + status.userKey
                    + '|' + new Date(status.createdTime * 1000).getDay()
                    + '|' + new Date(status.createdTime * 1000).getDay()
                    if (instances[key] == undefined) {
                      statuses.push(status)
                      instances[key] = 1
                    }
                })
                var rowData = []
                var storePresenceTrue = []
                var storePresenceFalse = []
                var storePresenceNone = []
                var productPresenceTrue = {}
                var productPresenceFalse = {}
                var currentDate = new Date()
                var currentMonth = currentDate.getMonth()
                var months = 12
                var monthOffset = currentMonth - months
                for (var i=0; i<=months; i++) {
                  storePresenceTrue.push(new Set())
                  storePresenceFalse.push(new Set())
                  storePresenceNone.push(new Set())
                }
                var userKeys = new Set()
                statuses.forEach((status) => {
                  userKeys.add(status.userKey)
                })
                var promises = []
                userKeys.forEach((userKey) => {
                  if (this.userMap[userKey] == undefined) {
                    let promise = new Promise((resolve, reject) => {
                      this.db.object('users/' + userKey).valueChanges().subscribe((user) => {
                        this.userMap[userKey] = user
                        resolve()
                      })
                    })
                    promises.push(promise)
                  }
                })
                Promise.all(promises).then((results) => {
                  var checkedStoreProductKeys = new Set()
                  statuses.forEach((status) => {
                    if (this.brandKey !== undefined && this.brandKey !== status.brandKey) {
                      return
                    }
                    var row = status
                    let store = storeMap[status.storeKey]
                    let product = productMap[status.productKey]
                    let retailer = store ? retailerMap[store.retailerKey] : undefined
                    row['retailerName'] = retailer == undefined ? '' : retailer.name
                    row['storeName'] = store == undefined ? '' : store.name
                    row['productName'] = product == undefined ? '' : product.name
                    row['userEmail'] = this.userMap[status.userKey].email
                    row['notFound'] = (status.productKey == null)
                    if (status.currentPrice == null) {
                      row['price'] = true
                    }
                    var previousPrice = ''
                    statuses.forEach((s) => {
                      if (previousPrice === '' && s.createdTime < status.createdTime && s.productKey === status.productKey && s.storeKEy === status.storeKey) {
                        previousPrice = s.price
                      }
                    })
                    row['previousPrice'] = previousPrice
                    rowData.push(row)
                    var date = new Date(status.createdTime * 1000)
                    var month = date.getMonth()
                    var i = month - monthOffset
                    if (i > 12) {
                      i -= 12
                    }
                    if (!Object.keys(productPresenceTrue).includes(status.productKey)) {
                      productPresenceTrue[status.productKey] = []
                      productPresenceFalse[status.productKey] = []
                      for (var j=0; j<=months; j++) {
                        productPresenceTrue[status.productKey].push(new Set())
                        productPresenceFalse[status.productKey].push(new Set())
                      }
                    }
                    if (i >= 0 && i < storePresenceTrue.length) {
                      let storeProductKey = status.storeKey + '|' + status.productKey + '|' + i
                      if (!checkedStoreProductKeys.has(storeProductKey)) {
                        checkedStoreProductKeys.add(storeProductKey)
                        if (status.productKey == null) {
                          storePresenceNone[i].add(status.storeKey)
                        } else {
                          if (status.offered) {
                            storePresenceTrue[i].add(status.storeKey)
                            if (storePresenceFalse[i].has(status.storeKey)) {
                              storePresenceFalse[i].delete(status.storeKey)
                            }
                            if (!productPresenceFalse[status.productKey][i].has(status.storeKey)) {
                              productPresenceTrue[status.productKey][i].add(status.storeKey)
                            }
                          } else {
                            if (!storePresenceTrue[i].has(status.storeKey)) {
                              storePresenceFalse[i].add(status.storeKey)
                            }
                            if (!productPresenceTrue[status.productKey][i].has(status.storeKey)) {
                              productPresenceFalse[status.productKey][i].add(status.storeKey)
                            }
                          }
                        }
                      }
                    }
                  })
                  rowData.sort((a, b) => {
                    if (a.retailerKey == b.retailerKey) {
                      if (a.storeKey == b.storeKey) {
                        return b.createdTime - a.createdTime
                      } else {
                        return b.storeKey.localeCompare(a.storeKey)
                      }
                    } else {
                      return b.retailerKey.localeCompare(a.retailerKey)
                    }
                  })
                  this.rowData = rowData
                  var storePresences = []
                  var monthNames = []
                  var lastTotal = 0
                  var storePresenceCurrent = new Set()
                  var monthAbbrevs = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                  var productPresences = {}
                  var productLastTotal = {}
                  var productPresenceCurrent = {}
                  Object.keys(productPresenceTrue).forEach((productKey) => {
                    productPresences[productKey] = []
                    productLastTotal[productKey] = 0
                    productPresenceCurrent[productKey] = new Set()
                  })
                  for (var i=0; i<=months; i++) {
                    var total = 0
                    var added = 0
                    var lost = 0
                    var none = 0
                    var productTotal = {}
                    var productAdded = {}
                    var productLost = {}
                    Object.keys(productPresenceTrue).forEach((productKey) => {
                      productTotal[productKey] = 0
                      productAdded[productKey] = 0
                      productLost[productKey] = 0
                    })
                    if (i > 0) {
                      total = lastTotal
                      storePresenceTrue[i].forEach((storeKey) => {
                        if (!storePresenceCurrent.has(storeKey)) {
                          added++
                          total++
                          storePresenceCurrent.add(storeKey)
                        }
                      })
                      storePresenceFalse[i].forEach((storeKey) => {
                        if (storePresenceCurrent.has(storeKey)) {
                          lost++
                          total--
                          storePresenceCurrent.delete(storeKey)
                        }
                      })
                      Object.keys(productTotal).forEach((productKey) => {
                        productTotal[productKey] = productLastTotal[productKey]
                        productPresenceTrue[productKey][i].forEach((storeKey) => {
                          if (!productPresenceCurrent[productKey].has(storeKey)) {
                            productAdded[productKey]++
                            productTotal[productKey]++
                            productPresenceCurrent[productKey].add(storeKey)
                          }
                        })
                        productPresenceFalse[productKey][i].forEach((storeKey) => {
                          if (productPresenceCurrent[productKey].has(storeKey)) {
                            productLost[productKey]++
                            productTotal[productKey]--
                            productPresenceCurrent[productKey].delete(storeKey)
                          }
                        })
                      })
                    } else {
                      total = storePresenceTrue[i].size
                      storePresenceCurrent = storePresenceTrue[i]
                      Object.keys(productPresenceTrue).forEach((productKey) => {
                        productTotal[productKey] = productPresenceTrue[productKey][i].size
                        productPresenceCurrent[productKey] = productPresenceTrue[productKey][i]
                      })
                    }
                    lastTotal = total
                    Object.keys(productTotal).forEach((productKey) => {
                      productLastTotal[productKey] = productTotal[productKey]
                    })
                    none = storePresenceNone[i].size
                    var storePresence = {
                      total: total,
                      new: added,
                      lost: lost,
                      notFound: none
                    }
                    storePresences.push(storePresence)

                    Object.keys(productTotal).forEach((productKey) => {
                      var productPresence = {
                        total: productTotal[productKey],
                        new: productAdded[productKey],
                        lost: productLost[productKey],
                      }
                      productPresences[productKey].push(productPresence)
                    })

                    var m = currentDate.getMonth() - (months - i)
                    var d = new Date(currentDate.getFullYear(), m, 1)
                    var monthName = monthAbbrevs[d.getMonth()] + " '" + String(d.getFullYear()).substring(2,4)
                    monthNames.push(monthName)
                  }
                  this.storePresences = storePresences

                  var productPresencesSorted = []
                  Object.keys(productPresences).forEach((productKey) => {
                    if (this.productMap[productKey]) {
                      productPresencesSorted.push({
                        key: productKey,
                        name: this.productMap[productKey].name,
                        presence: productPresences[productKey]
                      })
                    }
                  })
                  productPresencesSorted.sort((a, b) => {
                    return a.name.localeCompare(b.name)
                  })
                  this.productPresences = productPresencesSorted

                  this.monthNames = monthNames
                })
              })
            })
          })
        })
      })
    })
  }

  private setUser(completion) {
    this.authService.user.subscribe((auth) => {
      if (auth != null) {
        this.db.object('uidUsers/' + auth.uid).valueChanges().subscribe((uidUser) => {
          this.userKey = Object.keys(uidUser)[0]
          this.db.object('users/' + this.userKey).valueChanges().subscribe((user) => {
            user['key'] = this.userKey
            this.user = user
            this.db.object('superuserUids').valueChanges().subscribe((superuserUids) => {
              this.superuser = Object.keys(superuserUids).includes(auth.uid)
              completion()
            })
          })
        })
      }
    })
  }

  private getAll(model, completion) {
    if (model === 'users' || model === 'places' || this.superuser) {
      this.db.object(model).valueChanges().subscribe((mapped) => {
        var objects = []
        Object.keys(mapped).forEach((key) => {
          var object = mapped[key]
          object['key'] = key
          objects.push(object)
        })
        completion(mapped, objects)
      })
    } else {
      var userModel = 'user' + model.charAt(0).toUpperCase() + model.slice(1)
      this.db.object(userModel + '/' + this.userKey).valueChanges().subscribe((userModels) => {
        var promises = []
        var objects = []
        var mapped = {}
        Object.keys(userModels).forEach(modelKey => {
          let promise = new Promise((resolve, reject) => {
            this.db.object(model + '/' + modelKey).valueChanges().subscribe((object) => {
              if (object != null) {
                object['key'] = modelKey
                objects.push(object)
                mapped[modelKey] = object
              }
              resolve()
            },
            error => {
              console.log(error)
              resolve()
            })
          })
          promises.push(promise)
        })
        Promise.all(promises).then((results) => {
          completion(mapped, objects)
        })
      })
    }
  }

  private createColumnDefs() {
    const columnDefs = [
      {
        headerName: 'Retailer',
        field: 'retailerName',
        width: 150,
      },
      {
        headerName: 'Store',
        field: 'storeName',
        width: 150,
      },
      {
        headerName: 'Captured Date/Time',
        field: 'createdTime',
        width: 175,
        cellRenderer: dateTimeRenderer,
      },
      {
        headerName: 'Not Found',
        field: 'notFound',
        width: 95,
        cellRenderer: yesRenderer,
      },
      {
        headerName: 'Product Name',
        field: 'productName',
        width: 150,
      },
      {
        headerName: 'Offered',
        field: 'offered',
        width: 70,
        cellRenderer: noRenderer,
      },
      {
        headerName: 'Stocked',
        field: 'stocked',
        width: 75,
        cellRenderer: noRenderer,
      },
      {
        headerName: 'Retail Price',
        field: 'currentPrice',
        width: 95,
      },
      {
        headerName: 'Price Changed',
        field: 'price',
        width: 115,
        cellRenderer: yesFalseRenderer,
      },
      {
        headerName: 'Previous Price',
        field: 'previousPrice',
        width: 120,
      },
      {
        headerName: 'Promotion',
        field: 'promotion',
        width: 95,
        cellRenderer: yesRenderer,
      },
      {
        headerName: 'Promotion Value',
        field: 'currentPromotion',
        width: 150,
      },
      {
        headerName: 'Promo End Date',
        field: 'currentPromotionEndTime',
        width: 175,
        cellRenderer: dateRenderer,
      },
      {
        headerName: 'User',
        field: 'userEmail',
        width: 175,
      },
    ]

    return columnDefs
  }
}

function dateTimeRenderer(params) {
  return params.value == null ? '' : new Date(params.value * 1000).toLocaleString()
}

function dateRenderer(params) {
  return params.value == null ? '' : new Date(params.value * 1000).toLocaleDateString()
}

function timeRenderer(params) {
  return params.value == null ? '' : new Date(params.value * 1000).toLocaleTimeString()
}

function yesRenderer(params) {
  return params.value ? 'Y' : ''
}

function yesFalseRenderer(params) {
  return params.value ? '' : 'Y'
}

function noRenderer(params) {
  return params.value ? '' : 'N'
}



// WEBPACK FOOTER //
// /Software/Workspaces/snowrise/snowrise-console/src/app/app.component.ts